(function () {
  function redirectToSelectedCollection(select) {
    if (!select || !select.value) return false;
    window.location.href = select.value;
    return true;
  }

  document.addEventListener("change", function (event) {
    if (event.target.matches("[data-collection-jump]")) {
      redirectToSelectedCollection(event.target);
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form.matches("[data-parts-finder]")) return;

    var select = form.querySelector("[data-collection-jump]");
    if (select && select.value) {
      event.preventDefault();
      redirectToSelectedCollection(select);
    }
  });
})();
